package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets15 {
  internal val _3_vayikra_14_txt: AssetResource by lazy { init__3_vayikra_14_txt() }

  internal val _3_vayikra_15_txt: AssetResource by lazy { init__3_vayikra_15_txt() }

  internal val _3_vayikra_16_txt: AssetResource by lazy { init__3_vayikra_16_txt() }

  internal val _3_vayikra_17_txt: AssetResource by lazy { init__3_vayikra_17_txt() }

  internal val _3_vayikra_18_txt: AssetResource by lazy { init__3_vayikra_18_txt() }

  internal val _3_vayikra_19_txt: AssetResource by lazy { init__3_vayikra_19_txt() }

  internal val _3_vayikra_20_txt: AssetResource by lazy { init__3_vayikra_20_txt() }

  internal val _3_vayikra_21_txt: AssetResource by lazy { init__3_vayikra_21_txt() }

  internal val _3_vayikra_22_txt: AssetResource by lazy { init__3_vayikra_22_txt() }

  internal val _3_vayikra_23_txt: AssetResource by lazy { init__3_vayikra_23_txt() }

  internal val _3_vayikra_24_txt: AssetResource by lazy { init__3_vayikra_24_txt() }

  internal val _3_vayikra_25_txt: AssetResource by lazy { init__3_vayikra_25_txt() }

  internal val _3_vayikra_26_txt: AssetResource by lazy { init__3_vayikra_26_txt() }

  internal val _3_vayikra_27_txt: AssetResource by lazy { init__3_vayikra_27_txt() }

  internal val _4_bamidbar_01_txt: AssetResource by lazy { init__4_bamidbar_01_txt() }

  internal val _4_bamidbar_02_txt: AssetResource by lazy { init__4_bamidbar_02_txt() }

  internal val _4_bamidbar_03_txt: AssetResource by lazy { init__4_bamidbar_03_txt() }

  internal val _4_bamidbar_04_txt: AssetResource by lazy { init__4_bamidbar_04_txt() }

  internal val _4_bamidbar_05_txt: AssetResource by lazy { init__4_bamidbar_05_txt() }

  internal val _4_bamidbar_06_txt: AssetResource by lazy { init__4_bamidbar_06_txt() }

  internal val _4_bamidbar_07_txt: AssetResource by lazy { init__4_bamidbar_07_txt() }

  internal val _4_bamidbar_08_txt: AssetResource by lazy { init__4_bamidbar_08_txt() }

  internal val _4_bamidbar_09_txt: AssetResource by lazy { init__4_bamidbar_09_txt() }

  internal val _4_bamidbar_10_txt: AssetResource by lazy { init__4_bamidbar_10_txt() }

  internal val _4_bamidbar_11_txt: AssetResource by lazy { init__4_bamidbar_11_txt() }

  internal val _4_bamidbar_12_txt: AssetResource by lazy { init__4_bamidbar_12_txt() }

  internal val _4_bamidbar_13_txt: AssetResource by lazy { init__4_bamidbar_13_txt() }

  internal val _4_bamidbar_14_txt: AssetResource by lazy { init__4_bamidbar_14_txt() }

  internal val _4_bamidbar_15_txt: AssetResource by lazy { init__4_bamidbar_15_txt() }

  internal val _4_bamidbar_16_txt: AssetResource by lazy { init__4_bamidbar_16_txt() }

  internal val _4_bamidbar_17_txt: AssetResource by lazy { init__4_bamidbar_17_txt() }

  internal val _4_bamidbar_18_txt: AssetResource by lazy { init__4_bamidbar_18_txt() }

  internal val _4_bamidbar_19_txt: AssetResource by lazy { init__4_bamidbar_19_txt() }

  internal val _4_bamidbar_20_txt: AssetResource by lazy { init__4_bamidbar_20_txt() }

  internal val _4_bamidbar_21_txt: AssetResource by lazy { init__4_bamidbar_21_txt() }

  internal val _4_bamidbar_22_txt: AssetResource by lazy { init__4_bamidbar_22_txt() }

  internal val _4_bamidbar_23_txt: AssetResource by lazy { init__4_bamidbar_23_txt() }

  internal val _4_bamidbar_24_txt: AssetResource by lazy { init__4_bamidbar_24_txt() }

  internal val _4_bamidbar_25_txt: AssetResource by lazy { init__4_bamidbar_25_txt() }

  internal val _4_bamidbar_26_txt: AssetResource by lazy { init__4_bamidbar_26_txt() }

  internal val _4_bamidbar_27_txt: AssetResource by lazy { init__4_bamidbar_27_txt() }

  internal val _4_bamidbar_28_txt: AssetResource by lazy { init__4_bamidbar_28_txt() }

  internal val _4_bamidbar_29_txt: AssetResource by lazy { init__4_bamidbar_29_txt() }

  internal val _4_bamidbar_30_txt: AssetResource by lazy { init__4_bamidbar_30_txt() }

  internal val _4_bamidbar_31_txt: AssetResource by lazy { init__4_bamidbar_31_txt() }

  internal val _4_bamidbar_32_txt: AssetResource by lazy { init__4_bamidbar_32_txt() }

  internal val _4_bamidbar_33_txt: AssetResource by lazy { init__4_bamidbar_33_txt() }

  internal val _4_bamidbar_34_txt: AssetResource by lazy { init__4_bamidbar_34_txt() }

  internal val _4_bamidbar_35_txt: AssetResource by lazy { init__4_bamidbar_35_txt() }

  internal val _4_bamidbar_36_txt: AssetResource by lazy { init__4_bamidbar_36_txt() }

  internal fun values(): List<AssetResource> = listOf(_3_vayikra_14_txt, _3_vayikra_15_txt,
      _3_vayikra_16_txt, _3_vayikra_17_txt, _3_vayikra_18_txt, _3_vayikra_19_txt, _3_vayikra_20_txt,
      _3_vayikra_21_txt, _3_vayikra_22_txt, _3_vayikra_23_txt, _3_vayikra_24_txt, _3_vayikra_25_txt,
      _3_vayikra_26_txt, _3_vayikra_27_txt, _4_bamidbar_01_txt, _4_bamidbar_02_txt,
      _4_bamidbar_03_txt, _4_bamidbar_04_txt, _4_bamidbar_05_txt, _4_bamidbar_06_txt,
      _4_bamidbar_07_txt, _4_bamidbar_08_txt, _4_bamidbar_09_txt, _4_bamidbar_10_txt,
      _4_bamidbar_11_txt, _4_bamidbar_12_txt, _4_bamidbar_13_txt, _4_bamidbar_14_txt,
      _4_bamidbar_15_txt, _4_bamidbar_16_txt, _4_bamidbar_17_txt, _4_bamidbar_18_txt,
      _4_bamidbar_19_txt, _4_bamidbar_20_txt, _4_bamidbar_21_txt, _4_bamidbar_22_txt,
      _4_bamidbar_23_txt, _4_bamidbar_24_txt, _4_bamidbar_25_txt, _4_bamidbar_26_txt,
      _4_bamidbar_27_txt, _4_bamidbar_28_txt, _4_bamidbar_29_txt, _4_bamidbar_30_txt,
      _4_bamidbar_31_txt, _4_bamidbar_32_txt, _4_bamidbar_33_txt, _4_bamidbar_34_txt,
      _4_bamidbar_35_txt, _4_bamidbar_36_txt)
}

private fun init__3_vayikra_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-14.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-14.txt")

private fun init__3_vayikra_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-15.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-15.txt")

private fun init__3_vayikra_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-16.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-16.txt")

private fun init__3_vayikra_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-17.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-17.txt")

private fun init__3_vayikra_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-18.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-18.txt")

private fun init__3_vayikra_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-19.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-19.txt")

private fun init__3_vayikra_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-20.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-20.txt")

private fun init__3_vayikra_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-21.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-21.txt")

private fun init__3_vayikra_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-22.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-22.txt")

private fun init__3_vayikra_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-23.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-23.txt")

private fun init__3_vayikra_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-24.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-24.txt")

private fun init__3_vayikra_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-25.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-25.txt")

private fun init__3_vayikra_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-26.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-26.txt")

private fun init__3_vayikra_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_3_vayikra-27.txt\")") as String, rawPath =
    "allChapters/_3_vayikra-27.txt")

private fun init__4_bamidbar_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-01.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-01.txt")

private fun init__4_bamidbar_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-02.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-02.txt")

private fun init__4_bamidbar_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-03.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-03.txt")

private fun init__4_bamidbar_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-04.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-04.txt")

private fun init__4_bamidbar_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-05.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-05.txt")

private fun init__4_bamidbar_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-06.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-06.txt")

private fun init__4_bamidbar_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-07.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-07.txt")

private fun init__4_bamidbar_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-08.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-08.txt")

private fun init__4_bamidbar_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-09.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-09.txt")

private fun init__4_bamidbar_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-10.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-10.txt")

private fun init__4_bamidbar_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-11.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-11.txt")

private fun init__4_bamidbar_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-12.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-12.txt")

private fun init__4_bamidbar_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-13.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-13.txt")

private fun init__4_bamidbar_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-14.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-14.txt")

private fun init__4_bamidbar_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-15.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-15.txt")

private fun init__4_bamidbar_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-16.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-16.txt")

private fun init__4_bamidbar_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-17.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-17.txt")

private fun init__4_bamidbar_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-18.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-18.txt")

private fun init__4_bamidbar_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-19.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-19.txt")

private fun init__4_bamidbar_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-20.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-20.txt")

private fun init__4_bamidbar_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-21.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-21.txt")

private fun init__4_bamidbar_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-22.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-22.txt")

private fun init__4_bamidbar_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-23.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-23.txt")

private fun init__4_bamidbar_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-24.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-24.txt")

private fun init__4_bamidbar_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-25.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-25.txt")

private fun init__4_bamidbar_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-26.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-26.txt")

private fun init__4_bamidbar_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-27.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-27.txt")

private fun init__4_bamidbar_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-28.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-28.txt")

private fun init__4_bamidbar_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-29.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-29.txt")

private fun init__4_bamidbar_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-30.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-30.txt")

private fun init__4_bamidbar_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-31.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-31.txt")

private fun init__4_bamidbar_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-32.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-32.txt")

private fun init__4_bamidbar_33_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-33.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-33.txt")

private fun init__4_bamidbar_34_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-34.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-34.txt")

private fun init__4_bamidbar_35_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-35.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-35.txt")

private fun init__4_bamidbar_36_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_4_bamidbar-36.txt\")") as String, rawPath =
    "allChapters/_4_bamidbar-36.txt")

public actual val SharedRes.assets.allChapters._3_vayikra_14_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_14_txt

public actual val SharedRes.assets.allChapters._3_vayikra_15_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_15_txt

public actual val SharedRes.assets.allChapters._3_vayikra_16_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_16_txt

public actual val SharedRes.assets.allChapters._3_vayikra_17_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_17_txt

public actual val SharedRes.assets.allChapters._3_vayikra_18_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_18_txt

public actual val SharedRes.assets.allChapters._3_vayikra_19_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_19_txt

public actual val SharedRes.assets.allChapters._3_vayikra_20_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_20_txt

public actual val SharedRes.assets.allChapters._3_vayikra_21_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_21_txt

public actual val SharedRes.assets.allChapters._3_vayikra_22_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_22_txt

public actual val SharedRes.assets.allChapters._3_vayikra_23_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_23_txt

public actual val SharedRes.assets.allChapters._3_vayikra_24_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_24_txt

public actual val SharedRes.assets.allChapters._3_vayikra_25_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_25_txt

public actual val SharedRes.assets.allChapters._3_vayikra_26_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_26_txt

public actual val SharedRes.assets.allChapters._3_vayikra_27_txt: AssetResource
  get() = CommonMainAssets15._3_vayikra_27_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_01_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_01_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_02_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_02_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_03_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_03_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_04_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_04_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_05_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_05_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_06_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_06_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_07_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_07_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_08_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_08_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_09_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_09_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_10_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_10_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_11_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_11_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_12_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_12_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_13_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_13_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_14_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_14_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_15_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_15_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_16_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_16_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_17_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_17_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_18_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_18_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_19_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_19_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_20_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_20_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_21_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_21_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_22_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_22_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_23_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_23_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_24_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_24_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_25_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_25_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_26_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_26_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_27_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_27_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_28_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_28_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_29_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_29_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_30_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_30_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_31_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_31_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_32_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_32_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_33_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_33_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_34_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_34_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_35_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_35_txt

public actual val SharedRes.assets.allChapters._4_bamidbar_36_txt: AssetResource
  get() = CommonMainAssets15._4_bamidbar_36_txt
